/// <reference types="vite/client" />

export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'https://dev.api.vizit.com';

export const CUBE_API_URL = import.meta.env.VITE_CUBE_API_URL ?? '';
export const PENDO_API_KEY = import.meta.env.VITE_PENDO_API_KEY;
export const PLAIN_APP_ID: string | undefined = import.meta.env.VITE_PLAIN_APP_ID;

export const VIZIT_ENV = import.meta.env.VITE_VIZIT_ENV ?? 'dev';
